export function HomePage() {
  return (
    <h1 className="d-flex flex-row justify-content-center mt-3">Startsida</h1>
  );
}
